import React, { useMemo } from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { ContextCard } from '~/api/models/leadads/context-card';

import Grid from '~/theseus/components/SelectorGrid';

const Container = styled.div`
  font-size: 12px;
  padding: 20px;
`;

const cardCss = css`
  padding: 10px;

  & > span {
    align-self: center;
    padding: 30px 20px 10px;
    font-size: 18px;
  }

  ul {
    list-style: disc;
    padding-left: 20px;

   li {
    margin-bottom: 10px;
   }
  }
`;

interface Props {
  onChange: (cardId: ContextCard['id']) => void;
  options: ContextCard[];
  selected: ContextCard['id'] | null;
  isLoading: boolean;
}

const ContextCardSelector: React.FC<Props> = (props) => {
  const {
    onChange,
    options,
    selected,
    isLoading,
  } = props;

  const gridItems = useMemo(
    () => options.map((card) => {
      const content = card.style === 'PARAGRAPH_STYLE'
        ? <p>{ card.content }</p>
        : <ul>{ card.content.map(item => <li key={item}>{item}</li>) }</ul>;

      return (
        <Grid.Item key={card.id} id={card.id} css={cardCss}>
          <span>{card.title}</span>
          <Container>
            { content }
          </Container>
        </Grid.Item>
      );
    }), [options],
  );

  return (
    <Grid
      label="Context Card Selector"
      isLoading={isLoading}
      selected={selected}
      onChange={onChange}
    >
      {gridItems}
    </Grid>
  );
};

export default ContextCardSelector;
